import { getCompany } from '../../_utils/storage_handler';

export const getQType = () => {
    return document.getElementById('order_qtype').value;
}

export const buildselectClientBody = () => {
    return {
        client: document.getElementById('order_client').value,
    }
}

export const validateSelectClient = (body) => {
    if(body.client === null || body.client === ''){
        throw new Error('Cliente vacío');
    }
}

export const buildAddItemBody = (price) => {
    return {
        productPrice: document.getElementById('order_product').value,
        product_ref: document.getElementById('order_product_ref').value,
        color: document.getElementById('order_color').value,
        color_ref: document.getElementById('order_color_ref').value,
        quantity: document.getElementById('order_quantity').value,
        type_quantity: getQType(),
        price: price
    }
}

export const cleanQuantityImput = () => {
    document.getElementById('order_quantity').value = 0;
}

export const validateAddItemt = (body) => {
    if(body.product === null || body.product === ''){
        throw new Error('Producto vacío');
    }

    if(body.color === null || body.color === ''){
        throw new Error('Color vacío');
    }

    if(body.quantity === null || body.quantity === ''){
        throw new Error('Cantidad vacía');
    }

    if(isNaN(body.quantity.replaceAll(" ","") || body.quantity.includes('.') || body.quantity.includes('-'))){
        throw new Error('Cantidad no es valor numérico entero positivo');
    }

    if(body.quantity < 0 || Number(Math.round(body.quantity)) !== Number(body.quantity)){
        throw new Error('Cantidad no es valor numérico entero positivo ');
    }

    if(body.quantity === 0 || body.quantity === '0'){
        throw new Error('Cantidad es cero');
    }

    if(body.q_type === null || body.q_type === ''){
        throw new Error('Medida vacía');
    }

    if(isNaN(body.price)){
        throw new Error('Precio no es valor numérico positivo');
    }

    if(body.price <= 0){
        throw new Error('Precio no es valor numérico positivo ');
    }
}

export const buildGenerateOrderBody = (items) => {
    let date_created = new Date();
    return {
        address_delivery: document.getElementById('order_address_delivery').value,
        date_created: `${date_created.getFullYear()}-${date_created.getMonth() + 1}-${date_created.getDate()}`,
        date_delivery: document.getElementById('order_date_delivery').value,
        notes: document.getElementById('order_notes').value,
        purchase_order: document.getElementById('order_purchase_order').value,
        company: getCompany(),
        items
    }
}

export const cleanOrderInputs = () => {
    cleanQuantityImput();
    document.getElementById('order_notes').value = '';
    document.getElementById('order_date_delivery').value = null;
    document.getElementById('order_purchase_order').value = '';
}

export const validateGenerateOrder = (body) => {
    if(body.client === null || body.client === ''){
        throw new Error('Cliente vacío');
    }

    if(body.items === null){
        throw new Error('No hay productos');
    }

    if(body.items.length === 0){
        throw new Error('No hay productos');
    }
}